import { render, staticRenderFns } from "./PreventiveHealthcare.vue?vue&type=template&id=0ea34c1b&scoped=true"
import script from "./PreventiveHealthcare.vue?vue&type=script&lang=js"
export * from "./PreventiveHealthcare.vue?vue&type=script&lang=js"
import style0 from "./PreventiveHealthcare.vue?vue&type=style&index=0&id=0ea34c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea34c1b",
  null
  
)

export default component.exports